import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';

/**
 * @type {function}
 * @desc Open error overlay.
 * @example
 * import * as confirmOverlay from 'utils/confirmOverlay';
 * const confirmed = await confirmOverlay.open( { message: 'string' } );
 */
export const open = ( { message, iconName, title, confirmViewConfig = {} } = {} ) => {
    log.debug( 'confirmOverlay.open()' );

    return new Promise( ( resolve ) => {
        overlay.open( {
            settings: {
                modalType: OVERLAY_VIEWS.CONFIRM_VIEW,
                showCloseButton: false,
                ignoreOutsideClick: true,
                onClose: () => resolve( false ),
            },
            config: {},
            data: {
                message,
                title,
                iconName,
                confirmViewConfig,
                onYesClick: () => {
                    resolve( true );
                    overlay.close();
                },
                onNoClick: () => {
                    resolve( false );
                    overlay.close();
                },
            },
        } );
    } );
};
